import { VolumeTemporality } from '~/hooks/useVolumeTemporality';
import FeedPage from '~/pageComponents/FeedPage';
import getPageMetaTagsProps from '~/pageProps/metatags';

export default FeedPage;

export const getServerSideProps = (req) => {
  const { subsection = '1h' } = req.query as { subsection: VolumeTemporality };
  return getPageMetaTagsProps({
    title: 'Best-selling objkts',
    description: `Objkts that sold the most in the last ${subsection}`,
  })();
};
